export const Mark = ({ className = "h-7 w-7" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="0" fill="currentColor" />
    <g fill="var(--paper)">
      <rect x="12" y="12" width="5" height="40" />
      <rect x="21" y="12" width="5" height="40" />
      <rect x="30" y="12" width="5" height="22" />
      <path d="M39 12h4a11 11 0 0 1 0 22h-4z" />
      <rect x="39" y="38" width="5" height="14" />
      <rect x="48" y="44" width="5" height="8" fill="var(--accent)" />
    </g>
  </svg>
);
